"use client";

import { useEffect, useState } from "react";
import styles from "./Preloader.module.scss";
import { BeatLoader } from "react-spinners";
import { usePathname } from "next/navigation";

export default function Preloader() {
  const pathname = usePathname();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => setLoading(false), 500);

    return () => clearTimeout(timer);
  }, [pathname]);

  if (!loading) return null;

  return (
    loading && (
      <div className={styles.preLoader}>
        <BeatLoader color="#ff4c00" />
      </div>
    )
  );
}
